// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"3c8a1401","513":"5a9f9f76","703":"90f57383","787":"0161fa9a"}[chunkId] + ".chunk.js";
};